import axios, { AxiosResponse } from "axios"
import { UpdatePersonaCommandProps } from "./Commands/UpdatePersonaCommand"

export async function updatePersonaById(
  requestBody: UpdatePersonaCommandProps
): Promise<AxiosResponse> {
  const response = await axios.put(`/Persona/${requestBody.id}`, requestBody)
  return response
}
